module.exports = "/packs/images/svg/logo~5ffd4c8f6614e25fd5e4c49e9714b972.svg";